import { SVGProps } from 'react';

export const Research = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        id="Fill 403"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 15H3V13H7V15ZM3 9H10V11H3V9ZM12 1L17 6H12V1ZM9 16C9 12.134 12.134 9 16 9C16.695 9 17.366 9.105 18 9.294V4.586L13.414 0H2C0.897 0 0 0.898 0 2V20C0 21.103 0.897 22 2 22H12.408C10.369 20.777 9 18.551 9 16Z"
        fill="currentColor"
      />
      <path
        id="Fill 404"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 19C14.346 19 13 17.654 13 16C13 14.346 14.346 13 16 13C17.654 13 19 14.346 19 16C19 17.654 17.654 19 16 19ZM20.167 18.753C20.691 17.963 21 17.018 21 16C21 13.243 18.757 11 16 11C13.243 11 11 13.243 11 16C11 18.757 13.243 21 16 21C17.018 21 17.963 20.691 18.753 20.167L22 23.414L23.414 22L20.167 18.753Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
